import React from 'react'
import { Box, Link, SvgIcon } from '@mui/material'

interface DealsLinkProps {
    locale: string
    t: (key: string) => string
    hidden?: boolean
    variant?: 'flyin' | 'cleartrip'
}

const DealsLink: React.FC<DealsLinkProps> = ({ locale, t, hidden = false }) => {
    if (hidden) return null

    const href = `/${locale}/offers`

    return (
        <Link
            href={href}
            underline="none"
            sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: 14,
                fontWeight: 500,
                color: 'text.primary',
                '&:hover': { color: 'primary.main' },
                transition: 'color 0.2s',
                marginRight: '6px',
                px: 0.7
            }}
        >
            <Box sx={{ mr: 0.7, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <SvgIcon sx={{ width: 17, height: 17, color: 'inherit' }}>
                    <svg width="17" height="17" fill="none" viewBox="0 0 24 24">
                        <path
                            d="M4 7V6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v1"
                            stroke="currentColor"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <rect width="20" height="13" x="2" y="7" rx="2" stroke="currentColor" strokeWidth="1.3" />
                        <circle cx="17" cy="12" r="1" fill="currentColor" />
                    </svg>
                </SvgIcon>
            </Box>
            {t('deals')}
        </Link>
    )
}

export { DealsLink }
export type { DealsLinkProps }
